import { Component, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

  export interface FaqItem {
  id: number;
  title: string;
  content: string;
  points?: string[];
  open: boolean;
  contentTwo?: string
}

@Component({
  selector: 'app-accordion',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule], 
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
    animations: [
      trigger('faqAnimation', [
        transition(':enter', [
          style({ height: '0px', opacity: 0 }),
          animate('500ms ease', style({ height: '*', opacity: 1 }))
        ]),
        transition(':leave', [
          style({ height: '*', opacity: 1 }),
          animate('500ms ease', style({ height: '0px', opacity: 0 }))
        ])
      ])
    ]
})
export class AccordionComponent {
  @Input() data: any[] = [];
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;

  toggleFaq(item: FaqItem) {
     this.data = this.data.map((faq) => ({
       ...faq,
       open: faq.id === item.id ? !faq.open : false,
     }));
   }
}